import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen overflow-hidden" }
const _hoisted_2 = { class: "absolute bottom-0 flex flex-col w-full items-center bg-white md:static md:block" }
const _hoisted_3 = { class: "information-tooltip-title" }
const _hoisted_4 = { class: "information-tooltip-text" }

import { store } from "./main"
import { computed, onMounted, watch } from "vue"
import AppHeader from "./components/Header.vue"
import AppLegend from "./components/MapLegend.vue"
import BaseMap from "./components/BaseMap.vue"
import HistogramSlider from "./components/HistogramSlider.vue"
import KeyNumbers from "./components/KeyNumbers.vue"
import PopUp from "./components/PopUp.vue"
import Stats from "./components/Stats.vue"
import VirtualVisit from "./components/VirtualVisit.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  store.initStore()
})

const tooltipPosition = computed(() => {
  return store.getTooltipPosition()
})


return (_ctx: any,_cache: any) => {
  const _component_KeyNumbersMobile = _resolveComponent("KeyNumbersMobile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppHeader),
      _createVNode(_component_KeyNumbersMobile),
      _createVNode(BaseMap)
    ]),
    _createVNode(PopUp),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Stats),
      _createVNode(KeyNumbers),
      _createVNode(HistogramSlider)
    ]),
    _createVNode(AppLegend),
    (_unref(store).getState().virtualVisitAlreadyOpened)
      ? (_openBlock(), _createBlock(VirtualVisit, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(store).getState().informationTooltip.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "information-tooltip",
          style: _normalizeStyle(tooltipPosition.value)
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(store).getState().informationTooltip.content.title), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(store).getState().informationTooltip.content.text), 1)
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})